import React from "react";
import { useComponentTranslation } from "@/services/i18n";
import { FiCreditCard, FiFileText, FiExternalLink } from "react-icons/fi";

const translations = {
  en: {
    title: "Billing",
    description: "Manage your subscription and payment methods",
    current_plan: "Current Plan",
    free_plan: "Free",
    pro_plan: "Pro",
    upgrade: "Upgrade to Pro",
    manage_subscription: "Manage Subscription",
    payment_method: "Payment Method",
    no_payment_method: "No payment method on file",
    add_payment: "Add Payment Method",
    invoices: "Invoices",
    no_invoices: "No invoices yet",
    coming_soon: "Coming Soon",
    coming_soon_desc: "Billing management is coming soon. Contact support for billing inquiries.",
  },
  fr: {
    title: "Facturation",
    description: "Gérez votre abonnement et vos méthodes de paiement",
    current_plan: "Plan actuel",
    free_plan: "Gratuit",
    pro_plan: "Pro",
    upgrade: "Passer à Pro",
    manage_subscription: "Gérer l'abonnement",
    payment_method: "Méthode de paiement",
    no_payment_method: "Aucune méthode de paiement enregistrée",
    add_payment: "Ajouter une méthode de paiement",
    invoices: "Factures",
    no_invoices: "Aucune facture pour le moment",
    coming_soon: "Bientôt disponible",
    coming_soon_desc: "La gestion de la facturation arrive bientôt. Contactez le support pour toute question.",
  },
};

export default function Billing() {
  const { t } = useComponentTranslation(translations);

  return (
    <div>
      <h1 className="text-2xl font-bold text-gray-900 mb-2">{t("title")}</h1>
      <p className="text-gray-500 mb-8">{t("description")}</p>

      <div className="max-w-2xl">
        {/* Coming Soon Notice */}
        <div className="bg-gray-50 border border-gray-200 rounded-xl p-8 text-center">
          <div className="w-12 h-12 bg-gray-100 rounded-full flex items-center justify-center mx-auto mb-4">
            <FiCreditCard className="w-6 h-6 text-gray-400" />
          </div>
          <h3 className="text-lg font-semibold text-gray-900 mb-2">{t("coming_soon")}</h3>
          <p className="text-gray-500">{t("coming_soon_desc")}</p>
        </div>

        {/* Preview of future UI - disabled */}
        <div className="mt-8 space-y-6 opacity-50 pointer-events-none">
          {/* Current Plan */}
          <div className="bg-white border border-gray-200 rounded-xl p-6">
            <div className="flex items-center justify-between">
              <div>
                <p className="text-sm text-gray-500 mb-1">{t("current_plan")}</p>
                <p className="text-xl font-semibold text-gray-900">{t("free_plan")}</p>
              </div>
              <button className="btn btn-primary" disabled>
                {t("upgrade")}
              </button>
            </div>
          </div>

          {/* Payment Method */}
          <div className="bg-white border border-gray-200 rounded-xl p-6">
            <div className="flex items-center justify-between">
              <div className="flex items-center gap-3">
                <FiCreditCard className="w-5 h-5 text-gray-400" />
                <div>
                  <p className="text-sm font-medium text-gray-900">{t("payment_method")}</p>
                  <p className="text-sm text-gray-500">{t("no_payment_method")}</p>
                </div>
              </div>
              <button className="btn btn-secondary" disabled>
                {t("add_payment")}
              </button>
            </div>
          </div>

          {/* Invoices */}
          <div className="bg-white border border-gray-200 rounded-xl p-6">
            <div className="flex items-center gap-3 mb-4">
              <FiFileText className="w-5 h-5 text-gray-400" />
              <p className="text-sm font-medium text-gray-900">{t("invoices")}</p>
            </div>
            <p className="text-sm text-gray-500">{t("no_invoices")}</p>
          </div>
        </div>
      </div>
    </div>
  );
}
